import React from "react";
import './App.css';
import "./dist/wu-icons-style.css";
import Weather from "./components/Weather/Weather";

const App = () => {

  return (
    <div>
      <Weather />
    </div>


  );
}

export default App;
